import { handleBonusNotificationInfo } from '../../../common/handleBonusNotificationInfo';

export const bonusNoConfirmationNotificationInfo = async (
    { actionInfo, actionId },
    { lang, syncClose, dispatch }
) => handleBonusNotificationInfo({ actionInfo, actionId, isConfirmation: false }, { lang, syncClose, dispatch });
